import { combineReducers } from 'redux';
import common from './common';
import filter from './filters';

export default combineReducers({ common, filter });
